<template>
	<section class="py-5">
		<div class="container">
			<div class="inner-sec-w3lss my-lg-5 my-3" v-for="item of descContentList" :key="item.id">
				<div class="row">
					<div class="col-lg-3 video-img mt-lg-0 mt-4">
						<img :src="item.newsPic" alt="" class="img-fluid">
					</div>
					<div class="col-lg-9 news-content px-lg-4 px-2">
						<h3 class="tittle-w3 pt-3">{{item.newsName}}</h3>
						<p class="mt-2">{{item.newsDesc}}</p>
						<div class="news-link">
							<a href="javascript:void(0)" class="btn mr-2 text-capitalize ml-2" @click="more(item.id)">了解详情</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'DescContent',
		props: ["descContentList"],
		methods: {
			more(id) {
				this.$router.push({
					path: '/robot/article/' + id
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/robot/components/DescContent.scss';
</style>